function getCSSVariable(variableName, fallback) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  return value || fallback;
}

function createTheme() {
  return {
    primary: getCSSVariable('--primary-color', '#FF521D'),
    secondary: getCSSVariable('--secondary', '#1d9777'),
    primaryBackground: getCSSVariable('--primary-background', '#f0f0f0'),
    primaryText: getCSSVariable('--primary-text', '#323232'),
    primaryBorder: getCSSVariable('--primary-border-color', '#9D9D9D'),
    secondaryColor: getCSSVariable('--secondary-color', '#1da782'),
    secondaryBackground: getCSSVariable('--secondary-background', '#ffffff'),
    secondaryText: getCSSVariable('--secondary-text', '#606060'),
    secondaryBorder: getCSSVariable('--secondary-border-color', '#f5f5f5'),
    tertiaryBackground: getCSSVariable('--tertiary-background', '#ff6e5e'),
    tertiaryText: getCSSVariable('--white', '#ffffff'),     
    quaternaryBackground: getCSSVariable('--quaternary-background', '#fce8e2'),
    success: getCSSVariable('--success', '#1da782'),
    warning: getCSSVariable('--warning', '#f7b761'),
    danger: getCSSVariable('--danger', '#f95353'),
    error: getCSSVariable('--error', '#f95353'),
    accentOne: getCSSVariable('--ui-gradient-brand', '#FF7A4D'),
    accentTwo: getCSSVariable('--ui-gradient-teal', '#0d9488'),
    accentThree: getCSSVariable('--ui-gradient-info', '#3baef6'),
    accentFour: getCSSVariable('--ui-gradient-success', '#10b981'),
    accentFive: getCSSVariable('--ui-gradient-purple', '#7c3aed'),
    accentSix: getCSSVariable('--ui-gradient-warning', '#f59e0b'),
  };
}

export default {
  dark: false,
  themes: {
    light: createTheme(),
  },
}
